import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const createIssueDismissModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-create-issue-dismiss-modal" */ './index'),
	),
	getPreloadProps: () => ({}),
});
